// Curated font options for the wordmark + accent script.
// Each entry: { value: css-font-family, label: human-readable, type: 'primary'|'accent' }

export const PRIMARY_FONTS = [
  { value: '"Playfair Display", serif', label: "Playfair Display — Elegant serif (default)" },
  { value: '"Cormorant Garamond", serif', label: "Cormorant Garamond — Classic & soft" },
  { value: '"Bodoni Moda", serif', label: "Bodoni Moda — Editorial high-contrast" },
  { value: '"DM Serif Display", serif', label: "DM Serif Display — Bold modern serif" },
  { value: '"Cinzel", serif', label: "Cinzel — Roman capitals, luxe" },
  { value: '"Marcellus", serif', label: "Marcellus — Refined inscription style" },
  { value: '"Fraunces", serif', label: "Fraunces — Warm & quirky" },
  { value: '"Outfit", sans-serif', label: "Outfit — Modern geometric sans" },
  { value: '"Manrope", sans-serif', label: "Manrope — Clean rounded sans" },
  { value: '"Space Grotesk", sans-serif', label: "Space Grotesk — Tech / modern sans" },
];

export const ACCENT_FONTS = [
  { value: '"Great Vibes", cursive', label: "Great Vibes — Calligraphic flourish (default)" },
  { value: '"Allura", cursive', label: "Allura — Romantic script" },
  { value: '"Dancing Script", cursive', label: "Dancing Script — Casual handwriting" },
  { value: '"Caveat", cursive', label: "Caveat — Marker-pen style" },
  { value: '"Sacramento", cursive', label: "Sacramento — Bold loops" },
  { value: '"Pinyon Script", cursive', label: "Pinyon Script — Delicate copperplate" },
  { value: '"Mr Dafoe", cursive', label: "Mr Dafoe — Vintage signature" },
  { value: '"Pacifico", cursive', label: "Pacifico — Surf / retro vibe" },
  { value: '"Playfair Display", serif', label: "Playfair Display — Match primary (no contrast)" },
  { value: '"Outfit", sans-serif', label: "Outfit — Sans (modern flat look)" },
];

export const findFont = (list, value) =>
  list.find((f) => f.value === value) || list[0];
